import { type PlaceholderScope } from "@msys/textutils";
import { Modal } from "@msys/ui";
import { Box, Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { GroupedPlaceholdersList } from "./GroupedPlaceholdersList.js";

interface Props {
  scope: PlaceholderScope;
  handleClose(): void;
}

export function AvailableReplacementsModal({ scope, handleClose }: Props) {
  const { t } = useTranslate(["OrganisationSettings", "Global"]);

  return (
    <Modal
      title={t("Using placeholders in texts", {
        ns: "OrganisationSettings",
      })}
      handleClose={handleClose}
      notInStack
      actionButtons={[
        {
          label: t("Close", {
            ns: "Global",
          }),
          handleClick: handleClose,
        },
      ]}
      maxWidth="md"
    >
      <Typography variant="body1" gutterBottom>
        {t(
          "You can use placeholders to fill in information automatically in different parts of your documents.",
          {
            ns: "OrganisationSettings",
          }
        )}
      </Typography>
      <Typography variant="body1">
        {t(
          "The following placeholders are available for use in the opening and closing texts of the documents listed below.",
          {
            ns: "OrganisationSettings",
          }
        )}
      </Typography>
      <Box
        sx={{
          pt: 2,
        }}
      >
        <GroupedPlaceholdersList scope={scope} />
      </Box>
    </Modal>
  );
}
